import { createContext, useContext, useState, useCallback } from "react";

const ToastContext = createContext(null);

const ICONS = { success: "✅", error: "❌", warning: "⚠️", info: "ℹ️" };
const COLORS = { success: "#16a34a", error: "#dc2626", warning: "#d97706", info: "#185fa5" };

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = "success", duration = 3800) => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration);
  }, []);

  const toast = {
    success: (msg, ms) => addToast(msg, "success", ms),
    error:   (msg, ms) => addToast(msg, "error",   ms),
    warning: (msg, ms) => addToast(msg, "warning",  ms),
    info:    (msg, ms) => addToast(msg, "info",     ms),
    // Compatibilite : de nombreux composants appellent showToast(message, type) comme fonction unique
    showToast: (msg, type = "success", ms) => addToast(msg, type, ms),
    // Compatibilite : Agenda.jsx (et potentiellement d'autres) appellent addToast(message, type) directement
    addToast,
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div style={{ position: "fixed", top: 24, right: 24, zIndex: 9999, display: "flex", flexDirection: "column", gap: 8, pointerEvents: "none" }}>
        {toasts.map(t => (
          <div
            key={t.id}
            style={{
              display: "flex", alignItems: "center", gap: 10,
              padding: "11px 16px", borderRadius: 9,
              background: COLORS[t.type], color: "#fff",
              fontSize: 13, fontWeight: 500, maxWidth: 380, minWidth: 220,
              boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
              animation: "toastIn 0.22s ease",
              pointerEvents: "auto",
            }}
          >
            <span style={{ fontSize: 16 }}>{ICONS[t.type]}</span>
            <span style={{ flex: 1 }}>{t.message}</span>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast doit être utilisé dans un ToastProvider");
  return ctx;
}
